import Api from './Api';

class ValidacaoPreSessaoApi extends Api {
    async analisarSituacaoProcesso(idSessao, numProcesso, tipoValidacao) {
        let result = await this.fetch(
            this.configuracao.urlBaseSessao + `/sessoes/${idSessao}/processos/${numProcesso}/tipo-validacao`,
            'POST',
            tipoValidacao,
            [{ parametro: 'Content-type', valor: 'text/plain' }]
        );
        return result.data;
    }
}

export default ValidacaoPreSessaoApi;
